import { safeDefine } from "../../registration/safe-define.js";
import { SliderFillElement } from "../../ui/slider/fill.js";
//#region src/define/ui/slider-fill.ts
safeDefine(SliderFillElement);
//#endregion

//# sourceMappingURL=slider-fill.js.map